module.exports = __webpack_public_path__ + "static/video-difusion-570-1ccc307723243611c8e7cedb109f6317.jpg";